export interface LogoProps {
  size?: number
  variant?: 'orange' | 'white'
}

export function Logo({ size = 30, variant = 'orange' }: LogoProps) {
  return (
    <img
      src={variant === 'white' ? '/brand/logo-mark-white.svg' : '/brand/logo-mark-orange.svg'}
      alt="NthAI"
      width={size}
      height={size}
      style={{ width: size, height: size, display: 'block', flex: 'none' }}
    />
  )
}
